if (!customElements.get('tiny-floating-benefits')) {
  customElements.define('tiny-floating-benefits', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.floating !== 'true' || this.motionObserver) return;
      this.motionMedia = window.matchMedia('(min-width: 990px) and (prefers-reduced-motion: no-preference)');
      this.motionVisible = false;
      this.updateMotion = () => {
        this.dataset.motionState = this.motionMedia.matches && this.motionVisible && !document.hidden ? 'running' : 'paused';
      };
      this.motionObserver = new IntersectionObserver(entries => {
        this.motionVisible = entries[0].isIntersecting;
        this.updateMotion();
      }, { threshold: 0 });
      this.motionObserver.observe(this.querySelector('.tl__benefits'));
      this.motionMedia.addEventListener('change', this.updateMotion);
      document.addEventListener('visibilitychange', this.updateMotion);
      this.dataset.motionReady = 'true';
      this.updateMotion();
    }

    disconnectedCallback() {
      this.motionObserver?.disconnect();
      this.motionMedia?.removeEventListener('change', this.updateMotion);
      document.removeEventListener('visibilitychange', this.updateMotion);
      this.motionObserver = null;
    }
  });
}
